import { PassengerType } from './passenger-type';

export class BookingPaxMapping {
    bookingId: number;
    passengerId: number;
    type: PassengerType;
}
